var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8296 24.2825C20.3921 24.2825 16.8296 20.72 16.8296 16.2825C16.8296 11.9075 20.3921 8.28247 24.8296 8.28247C29.2046 8.28247 32.8296 11.9075 32.8296 16.2825C32.8296 20.72 29.2046 24.2825 24.8296 24.2825ZM30.3921 26.2825C35.0171 26.2825 38.8296 30.095 38.8296 34.72V37.2825C38.8296 38.97 37.4546 40.2825 35.8296 40.2825H13.8296C12.1421 40.2825 10.8296 38.97 10.8296 37.2825V34.72C10.8296 30.095 14.5796 26.2825 19.2046 26.2825H20.2671C21.6421 26.97 23.2046 27.2825 24.8296 27.2825C26.4546 27.2825 27.9546 26.97 29.3296 26.2825H30.3921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.267920760f30acd7b6485eb25592c1e3.svg";
export { ForwardRef as ReactComponent };